import {
  mapState,
  mapMutations
} from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      amount: '0'
    }
  },
  components: {
    Loading
  },
  computed: {
    ...mapState(['lang', 'UUID', 'accessToken', 'SaleID', 'SaleType', 'AmountPayment','config']),
    ...mapMutations(['onMessageWs'])
  },
  methods: {
    back() {
      // this.$router.push({
      //   name: 'Main'
      // })
      this.$router.go(-1)
    },
    addAmount(int) {
      if (this.amount.length < 6) {
        if (parseInt(this.amount) === 0) {
          this.amount = ''
        }
        this.amount += int
      }
    },
    del() {
      if (parseInt(this.amount) > 0) {
        if (this.amount.length > 1) {
          this.amount = this.amount.substring(0, (this.amount.length - 1))
        } else {
          this.amount = '0'
        }
      } else {
        this.amount = '0'
      }
    },
    payment() {

      if (parseInt(this.amount) > 0) {
        this.$store.state.total = this.amount
        this.$store.state.history_page = 'Wallet'
        switch (this.$store.state.SaleID) {
          case 1:
            switch (this.$store.state.lang) {
              case 0:
                this.$store.state.orderName = 'Deposit'
                break;
              case 1:
                this.$store.state.orderName = 'เติมเงิน'
                break;
              case 2:
                this.$store.state.orderName = '存款'
                break;
            }
            this.itemImage = require('../assets/select_deposit.png')
            this.$store.state.AmountPayment = 0
            break;
        }
        this.$store.state.sale_subs = [{
          line: 1,
          item_id: '0',
          item_name: this.$store.state.orderName,
          qty: 1,
          price_id: 1,
          price_name: this.$store.state.orderName,
          price: parseFloat(this.$store.state.total),
          unit: "",
          image: this.itemImage
        }]
        this.$router.push({
          name: 'Type'
        })
      } else {
        let text = ''
        let title = ''
        switch (this.lang) {
          case 0:
            text = 'Please enter the price in the space.'
            title = 'Warning'
            break
          case 2:
            text = '請在空格中輸入價格。'
            title = '通知'
            break
          default:
            text = 'กรุณากรอกราคาลงในช่องว่าง'
            title = 'แจ้งเตือน'
            break
        }
        Swal(
          title,
          text,
          'warning'
        )
      }
    }
  },
  mounted() {
    // this.$socket.sendObj({
    //   command: 'receive_close'
    // })
    // this.$socket.sendObj({
    //   command: 'edc_cancel'
    // })
    console.log("IDWallet:",this.$store.state.IDWallet)
    // this.checkOpenWebsocket()
  }
}



// WEBPACK FOOTER //
// ./src/js/wallet.js